import React from "react";
import listImg from "../../img/list.svg";
import chat from "../../img/chat.svg";

class PatientOption extends React.Component {
  propTypes: {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired
  };
  handleMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
    //  debugger;
  };
  handleMouseEnter = event => {
    this.props.onFocus(this.props.option, event);
  };
  handleMouseMove = event => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };

  render() {
    return (
      <div>
        <div
          className={this.props.className}
          style={{ width: "85%", float: "left", height: "37px" }}
          onMouseDown={this.handleMouseDown}
          onMouseEnter={this.handleMouseEnter}
          onMouseMove={this.handleMouseMove}
          title={this.props.option.title}
        >
          <span>
            {this.props.option.nom} {this.props.option.prenom} ({this.props.option.matricule})
          </span>
        </div>
        <div
          className={this.props.className}
          style={{
            width: "15%",
            float: "right",
            borderRadius: "0",
            height: "37px",
            display: "flex",
            justifyContent: "space-evenly", //"space-between",
            paddingRight: "5px"
          }}
        >
          <span onClick={() => this.props.toggleChatModal(this.props.option)}>
            <figure
              className="image is-21x21"
              style={{ display: "inline-block" }}
            >
              <img alt="Doctors" src={chat} />
            </figure>
          </span>
          <span
            onClick={() => this.props.openHistoryModal(this.props.option.id)}
          >
            <figure
              className="image is-21x21"
              style={{ display: "inline-block" }}
            >
              <img alt="listImg" src={listImg} />
            </figure>
          </span>
        </div>
      </div>
    );
  }
}

export default PatientOption;



// WEBPACK FOOTER //
// ./src/components/utilities/PatientOption.js